import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import { ChakraProvider } from '@chakra-ui/react';
import "./i18n";
import { HelmetProvider } from 'react-helmet-async';

const container = document.getElementById('root');

// Wrap app providers into a clean component
const AppTree = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Provider store={store}>
          <ChakraProvider>
            <App />
          </ChakraProvider>
        </Provider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// If react-snap pre-rendered static HTML inside #root, hydrate it.
// Otherwise, create a fresh client root (e.g. during dev mode).
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, AppTree);
} else {
  ReactDOM.createRoot(container).render(AppTree);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();